import React from 'react';
import { useAuth } from '@/contexts/AuthContext';
import { Navigate } from 'react-router-dom';
import { SEOHead } from '@/components/SEOHead';
import PageProjectsManager from '@/components/admin/PageProjectsManager';

const AdminPageProjects = () => {
  const { user, loading } = useAuth();

  if (loading) {
    return <div className="flex items-center justify-center min-h-screen">Loading...</div>;
  }

  if (!user) {
    return <Navigate to="/admin/login" replace />;
  }

  return (
    <>
      <SEOHead 
        title="Manage Page Projects"
        description="Configure featured and gallery projects for each page"
      />
      
      <div className="min-h-screen bg-background pb-20 md:pb-0">
        <div className="container mx-auto p-6 space-y-6">
          <div>
            <h1 className="text-3xl font-bold">Page Projects</h1>
            <p className="text-muted-foreground">
              Configure which projects appear as featured and in galleries for each page
            </p>
          </div>

          <PageProjectsManager />
        </div>
      </div>
    </>
  );
};

export default AdminPageProjects;
